import { DjangoTimeStamped, TimeStamped } from '../django';
import { parseDate } from '../helpers/date';

export class AbstractLoan implements TimeStamped {
  amount: number;
  period: number;
  interestRate: number;
  effectiveInterestRate: number;
  feeAmount: number;
  taxAmount: number;
  score: number;
  scoreVersion: number;
  currency: string;
  agioAmount: number;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;

  constructor(data: AbstractLoan | DjangoAbstractLoan = {}) {
    if (data instanceof AbstractLoan) {
      bindAbstractLoanData(this, data);
    } else {
      bindDjangoAbstractLoanData(this, data);
    }
  }
}

export function parseAbstractLoan(data: DjangoAbstractLoan | AbstractLoan) {
  if (data) {
    return new AbstractLoan(data);
  } else {
    return undefined;
  }
}

function bindAbstractLoanData(abstractLoan: AbstractLoan, data: AbstractLoan) {
  abstractLoan.amount = data.amount;
  abstractLoan.period = data.period;
  abstractLoan.interestRate = data.interestRate;
  abstractLoan.effectiveInterestRate = data.effectiveInterestRate;
  abstractLoan.feeAmount = data.feeAmount;
  abstractLoan.taxAmount = data.taxAmount;
  abstractLoan.score = data.score;
  abstractLoan.scoreVersion = data.scoreVersion;
  abstractLoan.currency = data.currency;
  abstractLoan.agioAmount = data.agioAmount;
  // DJANGO TIMESTAMPED
  abstractLoan.created = data.created;
  abstractLoan.modified = data.modified;
}

////////////////////
// DJANGO SUPPORT //
////////////////////
export interface DjangoAbstractLoan extends DjangoTimeStamped {
  amount?: number;
  period?: number;
  interest_rate?: number;
  effective_interest_rate?: number;
  fee_amount?: number;
  tax_amount?: number;
  score?: number;
  score_version?: number;
  currency?: string;
  agio_amount?: number;
  // DJANGO TIMESTAMPED
  created?: string;
  modified?: string;
}

function bindDjangoAbstractLoanData(abstractLoan: AbstractLoan, data: DjangoAbstractLoan) {
  abstractLoan.amount = data.amount;
  abstractLoan.period = data.period;
  abstractLoan.interestRate = data.interest_rate;
  abstractLoan.effectiveInterestRate = data.effective_interest_rate;
  abstractLoan.feeAmount = data.fee_amount;
  abstractLoan.taxAmount = data.tax_amount;
  abstractLoan.score = data.score;
  abstractLoan.scoreVersion = data.score_version;
  abstractLoan.currency = data.currency;
  abstractLoan.agioAmount = data.agio_amount;
  // DJANGO TIMESTAMPED
  abstractLoan.created = parseDate(data.created);
  abstractLoan.modified = parseDate(data.modified);
}
